import { AllocatedNestedQuota } from './allocated-nested-quota';

export interface NestingAudit {
  distribute(offset: number): AllocatedNestedQuota[];
}

export class HighestPercentAllocation implements NestingAudit {
  constructor(private readonly _allocations: AllocatedNestedQuota[]) {}

  public distribute(offset: number): AllocatedNestedQuota[] {
    if (this._allocations.length === 0) {
      return this._allocations;
    }

    this._allocations.sort((a, b) => b.percentage() - a.percentage());
    const remaing = new Array(offset).fill(1);

    for (let [i, value] of remaing.entries()) {
      this._allocations[i]?.add(value);
    }

    return this._allocations;
  }
}

export class FirstQuotaAllocation implements NestingAudit {
  constructor(private readonly _allocation: AllocatedNestedQuota[]) {}

  public distribute(offset: number): AllocatedNestedQuota[] {
    if (this._allocation.length) {
      this._allocation[0]?.add(offset);
    }

    return this._allocation;
  }
}
